import { serverFetch } from "@core/server";

export const fetchReportDesigns = () => serverFetch("reportdesign");

export const fetchReportDesign = (id) => serverFetch(`reportdesign/${id}`);

export const exportReportDesign = (id) => serverFetch(`reportdesign/${id}/export`);

export const fetchShortReports = (vid) =>
  serverFetch("reportdesign/short", { queryParams: { vid } });

export const saveReportDesign = (item, isNew) =>
  serverFetch(isNew ? "reportdesign" : `reportdesign/${item.id}`, {
    method: isNew ? "POST" : "PUT",
    bodyData: item
  });

export const deleteReportDesign = (id) =>
  serverFetch(`reportdesign/${id}`, { method: "DELETE" });

export const importReportDesign = (item) =>
  serverFetch("reportdesign/import", { method: "POST", bodyData: item });

export const fetchReportHtml = (params, signal) =>
  serverFetch("report/design", { queryParams: params }, signal);
